export type Coach = {
  name: string
  role: string
  avatar: string
}

/**
 * Instructor photos used for the hero rating row and the review cards.
 * Swap each avatar URL for the real buyer's photo before launch.
 */
export const coaches: Coach[] = [
  {
    name: 'Megan Ellis',
    role: 'Independent barre instructor · Columbus, OH',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/423c7024-0d9b-4429-8b81-986bfea3aee1.jpg',
  },
  {
    name: 'Tasha Reed',
    role: 'Gym barre instructor · Atlanta, GA',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/cd64df10-6abd-4cd4-81b9-7cd69bd0c1a5.jpg',
  },
  {
    name: 'Daniela Ortiz',
    role: 'YMCA barre instructor · Phoenix, AZ',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/e4a7beaf-3fc8-4d49-8a3e-685038e0a7e4.jpg',
  },
  {
    name: 'Ryan Whitfield',
    role: 'Small-studio owner · Nashville, TN',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/d4c3cd3b-e513-4639-951c-5762d23b883a.jpg',
  },
  {
    name: 'Grace Lin',
    role: 'Independent barre instructor · Sacramento, CA',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/4e3d0b7f-0670-47ca-816d-de0b9a2b1981.jpg',
  },
  {
    name: 'Laura Bennett',
    role: 'Community-center instructor · Denver, CO',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/dd87482a-7bcc-4da3-9c54-3433481d27a6.jpg',
  },
]
